/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, DropdownSelectField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './CrewMembersTableComponent.module.scss';
import metadata from './CrewMembersTableComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';


function CrewMembersTableComponent(props) {

    const {
        updateWizardData,
        submissionVM,
        crewMembersTablePath
    } = props;

    let {
        data: crewMembersTableVM
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);


    const addCrewMembersTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            if(!crewMembersTableVM) {
                crewMembersTableVM = {};
            }

            crewMembersTableVM.value = crewMembersTableVM.value || []

           const CrewMembersTableObjVM = viewModelService.create(
                {},
                "pc",
                "edgegen.capabilities.policyjob.lob.recmarproduct.coverables.dto.marinepleasurecraft.boats.subdto.CrewMembersDTO"
            );

            CrewMembersTableObjVM.isValidationReq = true;

            crewMembersTableVM.pushElement(
                CrewMembersTableObjVM
            );
            
            _.set(submissionVM, crewMembersTableVM, crewMembersTableVM);
            const newSubmissionVM = viewModelService.clone(submissionVM);
            updateWizardData(newSubmissionVM);
        },
        [submissionVM, updateWizardData, crewMembersTableVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeCrewMemberItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            crewMembersTableVM.value.splice(index, 1);
            _.set(submissionVM.value, crewMembersTablePath, crewMembersTableVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, crewMembersTablePath, crewMembersTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'numFie') {
                 let CrewMemberArray = _.get(submissionVM, crewMembersTablePath);
                CrewMemberArray = CrewMemberArray.value
                const newNumber = CrewMemberArray?.length >= 2 ? CrewMemberArray[CrewMemberArray.length - 2].numFie + 1 : index + 1;

                if (CrewMemberArray[index].numFie === undefined) {
                    CrewMemberArray[index].numFie = newNumber;
                    _.set(submissionVM.value, crewMembersTablePath, crewMembersTableVM.value);
                } 

                const value = index + 1;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'name' || path === 'areaOfCoverage' || path === 'qualification' || path === 'certification' || path === 'otherComments') {
                const value = item[path] ? item[path] : '';
                const disabled = false;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        disabled={disabled}
                        value={value}
                    />
                );
            }

            if (path === 'itenaryNumber' || path === 'yearsOfOffExp' || path === 'yearsOfExp') {
                const value = item[path] ? item[path] : 0;
                const isreadOnly = path === 'itenaryNumber' ? true : false;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        readOnly={isreadOnly}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }  

           
        }, [crewMembersTablePath, crewMembersTableVM?.value, handleValueChange, submissionVM?.value])

    const removeCrewMembersTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeCrewMemberItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeCrewMemberItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`crewMembersTable`]: {
            data: crewMembersTableVM && crewMembersTableVM.length > 0 ? crewMembersTableVM.value : []
        }

    }), [crewMembersTableVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addCrewMembersTable,
            getTableCell,
            removeCrewMembersTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            crewMembersTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [crewMembersTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={crewMembersTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

CrewMembersTableComponent.propTypes = wizardProps;
export default withRouter(CrewMembersTableComponent);
